import { __module as t } from "../../../_virtual/isByteLength.js";
import { a as e } from "./util/assertString.js";
!function (t, o) {
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = function (t, e) {
    (0, r.default)(t), "object" === n(e) ? (o = e.min || 0, u = e.max) : (o = arguments[1], u = arguments[2]);
    var o,
      u,
      f = encodeURI(t).split(/%..|./).length - 1;
    return f >= o && (void 0 === u || f <= u);
  };
  var r = e && e.__esModule ? e : {
    default: e
  };
  function n(t) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  t.exports = o.default, t.exports.default = o.default;
}(t, t.exports);
var o = t.exports;
export { o as i };